export const STAGES = [
  { key: "ricerca", label: "Ricerca", dot: "bg-slate-400", chip: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700" },
  { key: "contatto", label: "Contatto", dot: "bg-sky-500", chip: "bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/60 dark:text-sky-300 dark:border-sky-800" },
  { key: "presentazione", label: "Presentazione Offerta", dot: "bg-amber-500", chip: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800" },
  { key: "valutazione", label: "Valutazione Titolare", dot: "bg-purple-500", chip: "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950/60 dark:text-purple-300 dark:border-purple-800" },
  { key: "chiuso", label: "Chiuso / Acquisito", dot: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800" },
];

export const stageInfo = (key) => STAGES.find((s) => s.key === key) || STAGES[0];

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const eur2 = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const dateIt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

// Monthly acquisition targets: 3/mese Ott-Dic 2026, 1/mese Gen-Mag 2027
export const MONTHLY_TARGETS = [
  { ym: "2026-10", label: "Ott 26", target: 3 },
  { ym: "2026-11", label: "Nov 26", target: 3 },
  { ym: "2026-12", label: "Dic 26", target: 3 },
  { ym: "2027-01", label: "Gen 27", target: 1 },
  { ym: "2027-02", label: "Feb 27", target: 1 },
  { ym: "2027-03", label: "Mar 27", target: 1 },
  { ym: "2027-04", label: "Apr 27", target: 1 },
  { ym: "2027-05", label: "Mag 27", target: 1 },
];

export const ATTIVITA_TIPI = [
  "Servizio Foto",
  "Consegna",
  "Incontro",
  "Riunione",
  "Chiamata",
  "Preventivo",
  "Evento/Torneo",
  "Follow-up",
  "Altro",
];

export const PORTFOLIO_STATI = [
  { key: "attiva", label: "Attiva", chip: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800", dot: "bg-emerald-500" },
  { key: "pausa", label: "In pausa", chip: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800", dot: "bg-amber-500" },
  { key: "chiusa", label: "Chiusa", chip: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700", dot: "bg-slate-400" },
];

export const statoInfo = (k) => PORTFOLIO_STATI.find((s) => s.key === k) || PORTFOLIO_STATI[0];

export const portfolioRicavi = (p) => (p.prodotti || []).reduce((a, x) => a + (Number(x.prezzo) || 0) * (Number(x.quantita) || 0), 0);
export const portfolioMargine = (p) => portfolioRicavi(p) - (Number(p.costi) || 0);

// Compenso di una SSD acquisita: override fisso/percentuale oppure % del collaboratore (fallback globale)
export const canaleOf = (s) => (s.progetto_id ? "experience" : (s.canale === "partner" || s.partner_id) ? "partner" : "privati");
export const CANALI = [
  { key: "privati", label: "Clienti Privati" },
  { key: "partner", label: "Partner" },
  { key: "experience", label: "Portrait Experience" },
];

export const compensoSsd = (s, collab, globalComm = 0.5, settings = null) => {
  const ricavo = s.ricavo || 0;
  const tipo = s.compenso_tipo || "default";
  if (tipo === "fisso") return Number(s.compenso_valore) || 0;
  if (tipo === "percentuale") return ricavo * (Number(s.compenso_valore) || 0);
  const ch = settings?.settore === "ritrattistica" ? settings?.commissioni_canale?.[canaleOf(s)] : null;
  if (ch != null) return ricavo * ch;
  const rate = collab && collab.commissione != null ? collab.commissione : globalComm;
  return ricavo * rate;
};

export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const GIORNI = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export const MOVIMENTO_AREE = [
  { key: "portfolio", label: "Portfolio" },
  { key: "collaboratori", label: "Collaboratori" },
  { key: "generale", label: "Generale" },
];
export const areaLabel = (k) => (MOVIMENTO_AREE.find((a) => a.key === k) || { label: k }).label;

export const MATERIALE_CATEGORIE = ["Immagini", "Testi", "Slide", "Presentazioni", "Showreel", "Altro"];

export const humanSize = (bytes) => {
  if (!bytes) return "—";
  const u = ["B", "KB", "MB", "GB"];
  let i = 0, n = bytes;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
};

// Rate di liquidazione: date valorizzate, ordinate crescenti
export const sortDates = (dates) => [...(dates || [])].filter(Boolean).sort();

// Assegna una data di acquisizione alla prima rata di liquidazione >= data (fallback: ultima)
export const rataIndex = (dataAcq, sortedDates) => {
  if (!sortedDates || sortedDates.length === 0) return 0;
  if (!dataAcq) return sortedDates.length - 1;
  const d = String(dataAcq).slice(0, 10);
  for (let i = 0; i < sortedDates.length; i++) {
    if (sortedDates[i] && d <= sortedDates[i]) return i;
  }
  return sortedDates.length - 1;
};

export const BONUS_TIPI = [
  { key: "clienti", label: "Clienti acquisiti", unit: "Clienti" },
  { key: "partner", label: "Partner attivati", unit: "Partner" },
  { key: "progetti", label: "Progetti (Experience)", unit: "Progetti" },
  { key: "posti", label: "Posti venduti (Experience)", unit: "Posti" },
];
export const bonusMode = (settings) => (settings?.settore === "ritrattistica" && BONUS_TIPI.some((b) => b.key === settings?.bonus_tipo) ? settings.bonus_tipo : "clienti");
export const bonusCount = (acq, settings) => {
  if (settings?.settore !== "ritrattistica") return acq.length;
  const m = bonusMode(settings);
  if (m === "partner") return acq.filter((s) => s.canale === "partner").length;
  if (m === "progetti") return new Set(acq.map((s) => s.progetto_id).filter(Boolean)).size;
  if (m === "posti") return acq.filter((s) => s.progetto_id).length;
  return acq.filter((s) => s.canale !== "partner").length;
};
export const bonusUnit = (settings) =>
  settings?.settore === "ritrattistica" ? BONUS_TIPI.find((b) => b.key === bonusMode(settings)).unit : "SSD";

export const AGENDA_TIPI = ["Appuntamento", "Chiamata", "Colloquio", "Lavoro", "Promemoria"];
export const portfolioIncassato = (p) => (p.incassi || []).reduce((a, x) => a + (Number(x.importo) || 0), 0);

export const acqKeys = (settings, partner = false) => {
  const stages = (partner ? settings?.stages_partner : settings?.stages) || [];
  const keys = stages.map((x) => x.key);
  const acq = (partner ? settings?.stage_acquisizione_partner : settings?.stage_acquisizione) || "chiuso";
  const i = keys.indexOf(acq);
  return new Set(i >= 0 ? keys.slice(i) : ["chiuso"]);
};
export const isAcq = (s, settings) => acqKeys(settings, s.canale === "partner").has(s.stage);
